<script lang="ts">
	import type { BaseProduct, FullProduct } from "$lib/js/elasticsearch/types"

  export let product: BaseProduct | FullProduct
</script>


{#if product.reviews_number && product.rating_average && product.rating_average >= 3}
  <a
    href="#reviews"
    class="reviews"
  >
    <span class="stars" style="width: {product.rating_average * 16}px"></span>
    <span class="stars-empty"></span>
    <span class="number">({product.reviews_number})</span>
  </a>
{/if}


<style lang="scss">
  .reviews {
    position: relative;
    display: flex;
    align-items: center;

    span.stars,
    span.stars-empty {
      display: inline-block;
      width: 81px;
      height: 15px;
      background-size: 16px;
      position: absolute;
      top: 4px;
      left: 0;
    }
    
    span.stars {
      background-image: url('/images/icons/star.png');
    }
    
    span.stars-empty {
      background-image: url('/images/icons/star-empty.png');
    }

    span.number {
      margin-left: 86px;
      color: var(--grey--b);
    }
  }
</style>